import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Valores } from '../models/valores.model';

@Injectable({
  providedIn: 'root'
})
export class MuroFiltrosService {
  private valoresSubject = new BehaviorSubject<Valores[]>([]);
  valores$ = this.valoresSubject.asObservable();

  constructor() { }

  setValores(valores: Valores[]) {
    this.valoresSubject.next(valores);
  }
  getValores(): Valores[] {
    return this.valoresSubject.value;
  }
}
